aha-graphic-icon {
  --aha-graphic-icon--border-radius: var(--Common--border-radius);

  display: inline-block;
}

aha-graphic-icon[shape='circle'] {
  --aha-graphic-icon--border-radius: 50%;
}

.aha-graphic-icon__box {
  display: inline-flex;
  place-content: center;
  border-radius: var(--aha-graphic-icon--border-radius);
  box-sizing: border-box;
  position: relative;
  width: var(--aha-graphic-icon--size);
  height: var(--aha-graphic-icon--size);
}

/* If we are not using one of the aha palette colors, we want to ensure that the background is a bit warmer and more vibrant.
   We can do this using a filter, but we want to make sure that it _only_ affects the background, and not the icon or border. */
.aha-graphic-icon__box::before {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: inherit;
  background-color: var(--aha-graphic-icon--background-color);
  filter: var(--aha-graphic-icon--filter);
  pointer-events: none;
}

/* We want the graphic-icon box to have a border that is the same color as the icon, but 30% opacity. */
.aha-graphic-icon__box::after {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: inherit;
  border-width: 1px;
  border-style: solid;
  border-color: inherit;
  opacity: 0.3;
  pointer-events: none;
}

.aha-graphic-icon__icon {
  color: inherit;
  transform-origin: center;
  scale: 0.6;
  pointer-events: none;

  /* Because we're not in the shadowDOM, we need !important to override some leaky styles in the app. */
  font-size: var(--aha-graphic-icon--size) !important;
  padding: 0 !important;
  margin: 0 !important;
}

.aha-graphic-icon__rendered-color {
  display: none;
}
